import LoadingSpinner from './loadingSpinner.ui';

export default LoadingSpinner;
